import {useCallback} from 'react';
import {InlineManual} from './inline-manual';
import {useServiceFactory} from '../service';

export function useInlineManual() {
	const instance = useServiceFactory(() => {
		return InlineManual.getInstance();
	});

	const showInlineManual = useCallback(() => {
		instance.showWidget();
	}, [instance]);

	return {
		showInlineManual,
	};
}